<template>
  <div>
    <el-breadcrumb separator="/" style="padding-bottom: 10px;">
      <el-breadcrumb-item>首页</el-breadcrumb-item>
      <el-breadcrumb-item>产品管理</el-breadcrumb-item>
      <el-breadcrumb-item>产品列表</el-breadcrumb-item>
    </el-breadcrumb>

    <div class="table">
      <div class="top">
        <div class="query-container">
          <el-row :gutter="20" class="query-row" label-width="100px">

            <el-col :span="6">
              <el-input  v-model="queryData.productName" placeholder="请输入搜索内容" />
            </el-col>

            <el-col :span="8">
              <el-select v-model="queryData.productExpire" clearable placeholder="请选择">
                <el-option
                    v-for="item in productExpireOptions"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value">
                </el-option>
              </el-select>

            </el-col>

            <el-col :span="10" style="float:right">
              <el-button type="primary" @click="onSubmit" icon="el-icon-search"> 查询</el-button>
              <el-button type="primary" @click="reset" icon="el-icon-refresh">重置</el-button>
              <el-button type="primary" @click="add()" icon="el-icon-plus" v-if="userType==2 || userType ==4">新增</el-button>
            </el-col>
          </el-row>
        </div>
      </div>

      <div class="content">
        <el-card class="box-card">
        <el-table :data="tableData" style="width: 100%">
          <el-table-column label="产品信息" min-width="25%">
            <template #default="{ row }">
              <div style="display: flex; align-items: center; "  :colspan="5">

                 <ImageCarousel :images="row.imageLists" class="product-image" style="margin-left: 10px; margin-right: 10px; width: 150px; height: 250px;" alt="商品图片"/>

                <div style="width: 60%; text-overflow: ellipsis; white-space: nowrap; overflow: hidden;">
                  <div class="product-item">
                    <span class="product-text show-overflow-tooltip" style="font-weight: bold; font-size: 16px; color: #2b85e4">{{ row.productName }}</span>
                  </div>
                  <div class="product-item">
                    <span class="product-text show-overflow-tooltip">产品单价(含运费) : </span> <span class="product-price show-overflow-tooltip"> ¥{{ row.productPrice}}</span>
                  </div>
                  <div  class="product-item">
                    <span class="product-text show-overflow-tooltip"> 产品类型 : {{ row.productType }}</span>
                  </div>
                  <div  class="product-item">
                    <span class="product-text show-overflow-tooltip" > 产品尺寸 : {{ row.dimension }}</span>
                  </div>
                  <div class="product-item">
                    <span class="product-text show-overflow-tooltip">产品材质 : {{ row.material }}</span>
                  </div>
                  <div class="product-item">
                    <span class="product-text show-overflow-tooltip">工艺描述 : {{ row.productDescribe }}</span>
                  </div>

                  <div class="product-item">
                    <span class="product-text show-overflow-tooltip">订购数量范围 : {{ row.orderMinNumber }} - {{ row.orderMaxNumber }}</span>
                  </div>
                  <div class="product-item">
                    <span class="product-text show-overflow-tooltip">下单截止 : {{ row.expirationDateEnd }}</span>
                  </div>

                  <div class="product-item">
                    <span class="product-text show-overflow-tooltip">最后审核 : {{ row.examineTime }}</span>
                  </div>

                  <div class="product-item">
                    <span class="product-text show-overflow-tooltip">预计发货 : {{ row.expectedDeliveryTime }}</span>
                  </div>

                </div>
              </div>
            </template>
          </el-table-column>

          <el-table-column label="下单数量" prop="quantity" min-width="13%;">
            <template #default="{ row }">
              <el-input-number size="small" v-bind:value="row.quantity || row.orderMinNumber" v-model="row.quantity"  :min="row.orderMinNumber" :max="row.orderMaxNumber" @change="handleChange" ></el-input-number>
            </template>
          </el-table-column>

          <el-table-column label="下单地址" prop="address" min-width="12%;">
            <template slot-scope="scope">
              <el-select v-model="scope.row.addressId" placeholder="请选择" size="small"
                         @change="handleSelectChange(scope.row, $event)">
                <el-option
                    v-for="item in addressOptions"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value">
                </el-option>
              </el-select>
            </template>
          </el-table-column>

          <el-table-column label="收件人" prop="addressName" min-width="8%;">
            <template slot-scope="scope">
              <el-input readonly  v-model="scope.row.addressName" size="small"></el-input>
            </template>
          </el-table-column>

          <el-table-column label="收件人电话" prop="addressPhone" min-width="8%;">
            <template slot-scope="scope">
              <el-input readonly  v-model="scope.row.addressPhone" size="small"></el-input>
            </template>
          </el-table-column>

          <el-table-column label="沟通凭证" min-width="8%;">
            <template slot-scope="scope">
              <el-upload
                  ref="rowUpload"
                  class="upload-demo"
                  action="/movie/v1/file/upload"
                  :multiple="true"
                  :before-upload="beforeUpload"
                  :on-success="(response, file, fileList) => handleRowSuccess(response, scope.row)"
                  :on-remove="handleRowRemove"
                  :file-list="rowFileList"
                  :show-file-list="false"
              >
                <el-button size="small" type="primary" v-if="userType!=3">点击上传</el-button>
              </el-upload>

              <div v-if="scope.row.rowImageUrls && scope.row.rowImageUrls.length">
                <ul>
                  <li v-for="(image, index) in scope.row.rowImageUrls" :key="index" style="display: inline-block; margin: 10px;">
                    <img :src="image" alt="uploaded image" style="width: 100px; height: 100px; object-fit: cover;">
                    <button type="button" @click="handleRemoveRowPreview(scope.row, index)" style="display: block; margin-top: 5px;" class="button-del">删除</button>
                  </li>
                </ul>
              </div>
            </template>

          </el-table-column>

          <el-table-column label="操作" min-width="7%;" >
            <template #default="{ row }">
<!--              v-show="row.productExpire === 1"-->
              <div style="text-align: right;" >

                <el-button style=" color: #C24343; margin-bottom: 5px;border-radius: 20px;border: -1px solid #409EFF;"
                           @click = "edit(row)" size="mini" v-if="userType==2 || userType ==4">
                  <i class="el-icon-edit" ></i>
                  编辑
                </el-button>

                <el-button style=" color: #C24343; margin-bottom: 5px;border-radius: 20px;border: -1px solid #409EFF;"
                           @click = "createOrderOne(row)" size="mini" v-if="userType!=3 && row.productExpire === 1">
                  <i class="el-icon-document-add"></i>
                  下单
                </el-button>
                <el-button size="mini" style="float: right;  color: #C24343; margin-bottom: 5px;border-radius: 20px;border: -1px solid #409EFF;"
                           @click="addToCart({
                            productImageUrl : row.imageLists[0],
                            productId: row.productId,
                            productName: row.productName,
                            quantity: Number(row.quantity),
                            productType: row.productType,
                            expirationDateEnd: row.expirationDateEnd,
                            orderMinNumber: Number(row.orderMinNumber),
                            orderMaxNumber: Number(row.orderMaxNumber),
                            productPrice: row.productPrice,
                            addressId:row.addressId,
                            addressName:row.addressName,
                            addressPhone:row.addressPhone,
                            address:row.address,
                            serialNumber:serialNumber++,
                            quantity : row.quantity === undefined ? Number(row.orderMinNumber) : row.quantity
                           })"
                           v-if="userType!=3 && row.productExpire === 1">
                  <i class="el-icon-shopping-cart-full" ></i>
                  加入购物车
                </el-button>

                <el-button style="color: #C24343; margin-bottom: 5px;border-radius: 20px;border: -1px solid #b71a1a; "
                           size="mini" @click = "showDeleteDialog(row)" v-if="userType==2 || userType ==4">
                  <i class="el-icon-delete"></i>
                  删除
                </el-button>
              </div>
            </template>
          </el-table-column>
        </el-table>

        </el-card>
        <!-- 删除二次确认 -->
        <delete-confirmation
            :visible="dialogDelete"
            @update:visible="dialogDelete = $event"
            @confirm-delete="handleDelete"
        />

      </div>
      <div class="bottom">
        <el-pagination @size-change="handleSizeChange" @current-change="changePage"
                       :current-page="queryData.pageNo"
                       :page-sizes="[15, 25, 40, 50]" :page-size="queryData.size"
                       layout="total, sizes, prev, pager, next, jumper"
                       :total="total" style="float: right;">
        </el-pagination>
      </div>

      <!-- 购物车 -->
      <div>
        <!-- 购物车悬浮图标 -->
        <div class="cart-icon" @click="toggleCart" :class="{'has-items': cartCount > 0}" >
          <el-badge :value="cartCount" max="9">
            <el-button style="font-size: 30px" icon="el-icon-shopping-cart-full" circle></el-button>
          </el-badge>
        </div>

        <!-- 购物车弹窗 -->
        <el-dialog title="购物车" ref="catDialog" :visible.sync="cartVisible" width="80%" @open="handleDialogOpen">
          <el-card class="box-card">
              <el-table :data="cartItems" ref="catTable" style="width: 100%" :show-header="true"  @selection-change="handleSelectionChange">
                <!-- 勾选框列 -->
                <el-table-column
                    type="selection"
                    width="55"
                    :selectable="selectable"
                ></el-table-column>

                <el-table-column prop="productImageUrl" label="商品图片" :flex="1">
                  <template slot-scope="scope">
                    <img :src="scope.row.productImageUrl" style="width: 100px; height:100px" alt="Image" />
                  </template>
                </el-table-column>
                <el-table-column prop="productName" label="商品" :flex="1"></el-table-column >
                <el-table-column prop="quantity" label="数量" :flex="1" >
                  <template slot-scope="scope">
                    <el-input-number :controls="false" size="mini" v-model="scope.row.quantity" style="width: 100%;" ></el-input-number>
                  </template>
                </el-table-column>
                <el-table-column prop="productType" label="产品类型" :flex="1"></el-table-column>
<!--                <el-table-column prop="expirationDateEnd" label="下单截止时间"></el-table-column>-->
<!--                <el-table-column prop="orderMinNumber" label="最小起订数"></el-table-column>-->
<!--                <el-table-column prop="orderMaxNumber" label="最大购买数"></el-table-column>-->
                <el-table-column prop="productPrice" label="单价" :flex="1">
                  <template slot-scope="scope">
                    {{scope.row.productPrice}}
                    <span>¥</span>
                  </template>
                </el-table-column>

                <el-table-column prop="totalAmount" label="总价" :flex="1">
                  <template slot-scope="scope">
                    {{scope.row.productPrice * scope.row.quantity}}
                    <span>¥</span>
                  </template>
                </el-table-column>

                <el-table-column label="下单地址" prop="address">
                  <template slot-scope="scope">
                    <el-select v-model="scope.row.addressId" placeholder="请选择" size="small"
                               @change="handleSelectChange(scope.row, $event)">
                      <el-option
                          v-for="item in addressOptions"
                          :key="item.value"
                          :label="item.label"
                          :value="item.value">
                      </el-option>
                    </el-select>
                  </template>
                </el-table-column>

                <el-table-column label="收件人" prop="addressName">
                  <template slot-scope="scope">
                    <el-input readonly  v-model="scope.row.addressName" size="small"></el-input>
                  </template>
                </el-table-column>

                <el-table-column label="收件人电话" prop="addressPhone">
                  <template slot-scope="scope">
                    <el-input readonly  v-model="scope.row.addressPhone" size="small"></el-input>
                  </template>
                </el-table-column>
                <el-table-column label="操作" >
                  <template slot-scope="scope">
                    <el-button style="color: #C24343; margin-bottom: 5px;border-radius: 20px;border: -1px solid #b71a1a; "
                               size="mini" @click = "deleteCart(scope)">
                      <i class="el-icon-delete"></i>
                      删除
                    </el-button>
                  </template>
                </el-table-column>
              </el-table>
            <div style="float: right; height: 40px; padding: 15px 15px;"><span>合计：</span><span>{{this.cartData.cartTotal}}￥</span></div>
          </el-card>

          <el-card class="box-card flex-right" style="margin-top: 20px; ">

            <el-form label-width="100px">

              <el-form-item label="沟通凭证:" prop="productType" style="width: 100%">
                <el-upload
                    ref="cartUpload"
                    class="upload-demo"
                    action="/movie/v1/file/upload"
                    :before-upload="beforeUpload"
                    :on-preview="handleCartPreview"
                    :on-success = "handleCartSuccess"
                    :on-remove="handleCartRemove"
                    :file-list="cartData.fileList"
                >
                  <el-button size="small" type="primary">点击上传</el-button>
                </el-upload>
              </el-form-item>

              <el-form-item label="凭证预览:" prop="productType" style="width: 85%">
                <div v-if="this.cartDataImageUrls.length > 0">
                  <ul>
                    <li v-for="(image, index) in this.cartDataImageUrls" :key="index" style="display: inline-block; margin: 10px;">
                      <img :src="image" alt="uploaded image" style="width: 150px; height: 150px; object-fit: cover;">
                      <button type="button" @click="handleRemoveCartPreview(index)" style="display: block;margin-top: 5px;" class="button-del">删除</button>
                    </li>
                  </ul>
                </div>
              </el-form-item>

            </el-form>

          </el-card>

        <span slot="footer" class="dialog-footer">
            <el-button @click="cartVisible = false">取消</el-button>
            <el-button type="primary" @click="createOrder">结算</el-button>
        </span>
        </el-dialog>
        <!--购物车 结束... -->

      </div>

    </div>
    <el-dialog title="新增/编辑" :visible.sync="dialogVisible" width="50%">
      <span>
        <el-form ref="formValidate" :model="product" size="mini" label-width="150px" class="demo-ruleForm" :rules="ruleValidate">
          <el-form-item label="产品Id" prop="productId" style="width: 85%" v-if="product.mode==1">
            <el-input v-model="product.productId" disabled></el-input>
          </el-form-item>

          <el-form-item label="产品名称" prop="productName" style="width: 85%">
            <el-input v-model="product.productName" placeholder="请输入产品名称"></el-input>
          </el-form-item>

          <el-form-item label="产品类型" prop="productType" style="width: 85%">
            <el-input v-model="product.productType" placeholder="请输入产品类型"></el-input>
          </el-form-item>

          <el-form-item label="尺寸" prop="dimension" style="width: 85%">
            <el-input v-model="product.dimension" placeholder="请输入尺寸"></el-input>
          </el-form-item>

          <el-form-item label="材质" prop="material" style="width: 85%">
            <el-input v-model="product.material" placeholder="请输入材质"></el-input>
          </el-form-item>

          <el-form-item label="产品工艺描述" prop="productDescribe" style="width: 85%">
            <el-input v-model="product.productDescribe" placeholder="请输入产品工艺描述"></el-input>
          </el-form-item>

          <el-form-item label="产品单价(含运费)" prop="productPrice" style="width: 85%">
            <el-input v-model="product.productPrice" placeholder="请输入产品单价" type="number"
                      @blur="valueChange"></el-input>
          </el-form-item>

          <el-form-item label="最小起订数" prop="orderMinNumber" style="width: 85%">
            <el-input v-model="product.orderMinNumber" placeholder="请输入每笔最小起订数" type='number'></el-input>
          </el-form-item>

          <el-form-item label="最大订购数" prop="orderMaxNumber" style="width: 85%">
            <el-input v-model="product.orderMaxNumber" placeholder="请输入最大订购数" type='number'></el-input>
          </el-form-item>

          <el-form-item label="产品有效期" prop="data" style="width: 85%">
          <el-date-picker v-model="product.data" style="width:100%" type="daterange" value-format="yyyy-MM-dd HH:mm:ss" align="right"
                          unlink-panels range-separator="至" start-placeholder="开始日期"
                          end-placeholder="结束时间">
            </el-date-picker>
          </el-form-item>

          <el-form-item label="最后审核期限" prop="data" style="width: 85%">
              <el-date-picker
                  v-model="product.examineTime"
                  type="datetime"
                  placeholder="选择日期时间">
              </el-date-picker>
          </el-form-item>

           <el-form-item label="快递预计发出时间" prop="data" style="width: 85%">
              <el-date-picker
                  v-model="product.expectedDeliveryTime"
                  type="datetime"
                  placeholder="选择日期时间">
              </el-date-picker>
          </el-form-item>

          <!-- Element UI 文件上传组件，支持多文件上传 -->
          <el-form-item label="图片">
            <!-- 上传组件 -->
            <el-upload
                ref="upload"
                class="upload-component"
                drag
                action="/movie/v1/file/upload"
                list-type="picture-card"
                :multiple="true"
                :before-upload="beforeUpload"
                :on-success = "handleSuccess"
                :on-remove="handleRemove"
                :show-file-list="false"
                accept="image/*"
            >
                  <i class="el-icon-upload">点击上传</i>
            </el-upload>
          </el-form-item>

          <el-form-item label="图片预览">
            <div v-if="this.productFile.length > 0">
              <ul>
                <li v-for="(image, index) in this.productFile" :key="index" style="display: inline-block; margin: 10px;">
                  <img :src="image" alt="uploaded image" style="width: 100px; height: 100px; object-fit: cover;">
                  <button type="button" @click="removePreview(index)" style="display: block;margin-top: 5px;" class="button-del">删除</button>
                </li>
              </ul>
            </div>
          </el-form-item>
        </el-form>

      </span>
      <span slot="footer" class="dialog-footer">
    <el-button size="small" @click="dialogVisible = false" style="float:left">取 消</el-button>
         <el-form ref="queryData" :model="product" label-width="100px" size="mini">
            <el-button size="small" type="primary" @click="createProduct(product)" v-if="product.mode==0">保存</el-button>
            <el-button size="small" type="primary" @click="updateProduct(product)" v-if="product.mode==1">修改</el-button>
         </el-form>

  </span>
    </el-dialog>

  </div>
</template>

<script>

import {
  productList,
  createProduct,
  removeProduct,
  updateProduct,
  deleteProduct,
  createOrder,
  getAddress,
  expressDetail,
  expressFee
} from "../../request/api.js";
import axios from "axios";
import ImageCarousel from '@/components/ImageCarousel.vue';
import DeleteConfirmation from '@/components/DeleteConfirmation.vue';
import dayjs from 'dayjs';
// import {sourceMap} from "@vue/cli-service/lib/config/terserOptions";

export default {
  name: "Position",
  data() {
    return {
      pdfurl: "https://jianghexing-oss.oss-cn-beijing.aliyuncs.com/img/【曹操出行-122.57元-1个行程】高德打车电子行程单.pdf",

      fileList: [], // 保存上传的文件列表
      imagePreviews: [], // 存储多个图片预览的路径
      uploadResponse: null,
      userType: window.sessionStorage.getItem('userType'),
      state1:"",
      restaurants:[],
      addressPage:"",

      rowFileList:[],
      rowImageUrls:[],
      serialNumber:0,
      total: 0,

      queryTime:[],

      queryData: {
        productExpire:'1',
        productName: null,
        startTime:"",
        endTime:"",
        pageNo: 1,
        size: 15,
      },

      pickerOptions: {
        shortcuts: [{
          text: '最近一周',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: '最近一个月',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: '最近三个月',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
            picker.$emit('pick', [start, end]);
          }
        }]
      },

      productExpireOptions: [{
        value: '0',
        label: '全部'
      }, {
        value: '1',
        label: '在售'
      }, {
        value: '2',
        label: '已过期'
      }],

      // imageLists: ["https://jianghexing-oss.oss-cn-beijing.aliyuncs.com/img/IMG_2359.PNG.JPG"],
      productCreateStatus: window.sessionStorage.getItem('productCreateStatus'),
      orderCreateStatus: window.sessionStorage.getItem('orderCreateStatus'),
      productUpdateStatus: window.sessionStorage.getItem('productCreateStatus'),
      productDeleteStatus: window.sessionStorage.getItem('productCreateStatus'),
      queryForm: {
        show: false,
      },

      tableData: [
      ],

      dialogVisible: false,
      orderdialogVisible: false,
      productFile:[],
      product: {
        productId: "",
        productName: "",
        productDescribe: "",
        productSpecs: "",
        productPrice: "",
        productType: "",
        dimension: "",
        material: "",
        orderMinNumber: 0,
        orderMaxNumber: "",
        examineTime: "",
        expectedDeliveryTime: "",

        expirationDateStart: "",
        expirationDateEnd: "",
        imageUrls:[],

        expirationDateStart_Param: "",
        expirationDateEnd_Param: "",
        data:[],
        productOrders: "",

        productUrls:[],
        mode: 0,
        quantity: 0,
        // sum:this.product.printFee+this.product.inspectFee+this.product.serviceFee+this.product.manageFee+this.product.accessoriesFee+this.product.packFee
      },

      cartVisible: false, // 控制购物车弹窗显示
      cartItems: [],      // 购物车商品列表
      cartCount: 0,       // 购物车商品总数

      deleteMessage: '您确定要删除此项吗？删除后无法恢复。',
      itemToDelete: "",
      dialogDelete:false,

      selectedRows:[],
      cartData: {
        cartTotal:"",
        // 购物车中下来菜单
        addressValue:"",

        addressDetails:"",
        phoneNumber:"",
        nikeName:"",

        addressOptions:[],

        fileList:[],
        imageCartPreviews:[],
        // 审核预览文件列表
        examineImageUrls:[],
        // 下单的列表信息
        productDTOS:[],
        addressId:"",
        // 订单合同地址
        contractUrl:"",
        orderName:""
      },

      cartDataImageUrls:[],
      addressOptions:[],
      userAddressList: [],

      ruleValidate: {
        productName: [{
          required: true,
          message: '请输入产品名称',
          trigger: 'blur'
        }],
        productSpecs: [{
          required: true,
          message: '请输入规格',
          trigger: 'blur'
        }],
        productPrice: [{
          required: true,
          message: '请输入产品单价',
          trigger: 'blur'
        }],
       /* data: [{
          required: true,
          message: '请输入产品开始-结束时间',
          trigger: 'blur'
        }],*/
        productDescribe: [{
          required: true,
          message: '请输入产品描述',
          trigger: 'blur'
        }],
        productOrders: [{
          required: true,
          message: '请输入每笔最大订单数',
          trigger: 'blur'
        }],

        imageUrl: [{
          required: true,
          message: '请上传图片',
          trigger: 'blur'
        }],
      },
      ruleValidate1: {
        productNums: [{
          required: true,
          message: '请输入产品数量',
          trigger: 'blur'
        }],
        addressId: [{
          required: true,
          message: '请选择用户地址',
          trigger: 'blur'
        }],
      },
      inject: ['reload'],
    }
  },

  watch: {
    /*cartItems: {
      handler() {
        this.calculateTotal();
      },
      deep: true
    }*/
  },

  methods: {
    valueChange(e) {
      this.product.productPrice = (e.target.value.match(/^\d*(\.?\d{0,2})/g)[0]) || null;
    },
    handleChange(value) {
      console.log(value);
    },

    productList() {
      console.log("4,"+window.sessionStorage.getItem('productCreateStatus'));
      productList(this.queryData).then((data) => {
        if (data.code == 20000) {
          this.tableData = data.data.records;
          this.total = data.data.total;
        }
      })
    },

    queryAddress(queryString, cb) {
      var restaurants = this.restaurants;
      var results = queryString ? restaurants.filter(this.createFilter(queryString)) : restaurants;
      // 调用 callback 返回建议列表的数据
      console.log("===================>>>>>>>>> queryAddress" + JSON.stringify(results))
      cb(results);
    },

    handleSelectAddress(item) {
      console.log(">>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>: " + JSON.stringify(item))
      // row.address = item.value;
      this.addressPage = item.label;
    },

    createFilter(queryString) {
      return (restaurant) => {
        return (restaurant.value.toLowerCase().indexOf(queryString.toLowerCase()) === 0);
      };
    },

    handleSelectChange(row, newValue) {
      this.userAddressList.forEach(address => {
        if (address.id === newValue) {
          row.addressName = address.value.nikeName;
          row.addressPhone = address.value.phone;
          row.address = address.value.address;
          this.addressPage= address.value.address;

        }
      })
      console.log('当前行的数据:', row);
    },

    getAddress() {
      getAddress().then((data) => {
        /*data.data.list.forEach(address =>{
          this.cartData.addressOptions.push({"value": address, "label": address.address});
          // this.restaurants.push({"value": address.address, "label": address});
          this.restaurants.push({"value": address.address, "label": address});
        })*/
        var addressList = data.data.list;
        addressList.forEach(address => {
          this.addressOptions.push({"value": address.id, "label": address.address});
          this.userAddressList.push({"id": address.id, "value": address}) // 相对与页面暂存，存到详情表中
        })
      })
    },
    onSubmit() {
      if (this.queryTime.length > 0) {
         const start = new Date(this.queryTime[0]);
         const end = new Date(this.queryTime[1]);
         this.queryData.startTime = start;
        this.queryData.endTime = end;
      }

      productList(this.queryData).then((data) => {
        this.tableData = data.data.records;
        this.total = data.data.total;
        for (var i = 0; i < this.tableData.length; i++) {
          this.tableData[i].status = ((data.data.pageNo - 1) * 25 + i + 1)
        }
      })
    },
    reset() {
      this.queryData.orderState = null;
      this.queryData.productName = null;
    },

    beforeUpload(file) {
      // 假设我们设置的文件大小限制是2MB
      // 假设我们设置的文件大小限制是2MB
      const ALLOWED_EXTENSIONS = ['jpg', 'jpeg', 'png', 'gif', 'webp'];
      const extension = file.name.split('.').pop().toLowerCase();
      if (!ALLOWED_EXTENSIONS.includes(extension)) {
        this.$message.error('只支持上传 JPG/PNG/WEBP 格式的图片！');
        return false;
      }

      const MAX_SIZE = 2 * 1024 * 1024;
      if (file.size > MAX_SIZE) {
        this.$message.error('上传图片需要在2MB以内！');
        return false; // 阻止文件上传
      }
      return true; // 允许上传
    },

    handleSuccess(response) {
      if (response.code === 20000) {
        this.productFile.push(response.data.fileUrl);
        console.log('上传的文件 URL:', response.data.fileUrl);
        this.product.productUrls = this.productFile;

        this.uploadResponse = response;
        // 你可以根据返回的 fileUrl 做其他操作，如展示图片等
      } else {
        console.log('上传失败...:', response);
      }
    },

    // 删除图片预览时的回调
    removePreview(index) {
      // 删除预览图
      this.productFile.splice(index, 1);
      // handleRemove();
      const upload = this.$refs.upload;  // 获取 el-upload 组件的实例
      if (upload && upload.handleRemove) {
        const file = this.fileList[index]; // 获取要删除的文件，这里假设删除第一个文件
        upload.handleRemove(file, this.fileList);  // 手动触发删除操作
      }
    },

    // 删除文件时的回调（ElementUI 自带）
    handleRemove(file, fileList) {
      // 仅同步文件列表
      this.fileList = fileList;
      // 这里确保文件移除时，也移除对应的预览
      this.imagePreviews = this.imagePreviews.filter(preview => preview.url !== URL.createObjectURL(file.raw));
      this.productFile = this.productFile.filter(preview => preview.url !== file.url);
      console.log(">>>>>>>>>> 删除之后",this.productFile)
    },

    // 购物车的图片上传
    handleCartSuccess(response, file, fileList) {
      console.log(">>>>>>>>>> 购物车上传图片：",this.productFile)
      this.cartData.fileList = fileList;
      if (response.code === 20000) {
        this.cartDataImageUrls.push(response.data.fileUrl);
        console.log('上传的文件 URL:', response.data.fileUrl);
      } else {
        console.log('上传失败...:', response);
      }
    },

    // handleRowSuccess(row, response, file, fileList) {
    //
    //   if (response  == undefined) {
    //     return;
    //   }
    //   this.rowFileList = fileList;
    //   if (response.code === 20000) {
    //     this.rowImageUrls.push(response.data.fileUrl);
    //     row.rowImageUrls.push(response.data.fileUrl);
    //   } else {
    //     console.log('上传失败...:', response);
    //   }
    // },

    handleRowSuccess(response, row) {
      // 确保 rowImageUrls 是数组
      if (!row.rowImageUrls) {
        this.$set(row, 'rowImageUrls', []);
      }

      // 假设后端返回的图片 URL
      if (response) {
        this.$set(row.rowImageUrls, row.rowImageUrls.length, response.data.fileUrl);  // 强制 Vue 重新渲染
        // row.rowImageUrls.push(response.data.fileUrl); // 将图片 URL 添加到数组中
      }
    },

    handleRowRemove(file, fileList) {
      // 根据文件的 URL 删除相应的图片
      console.log("fileList" + fileList)
      const index = this.scope.row.rowImageUrls.indexOf(file.url);
      if (index !== -1) {
        this.scope.row.rowImageUrls.splice(index, 1);
      }
    },

    handleRemoveRowPreview(row, index) {
      // 删除预览图片
      this.rowFileList.splice(index, 1);
      row.rowImageUrls.splice(index, 1);
    },

    /*handleRowSuccess(row) {
      return (response, file, fileList) => {
        // 假设后端返回的响应中包含文件的 URL
        if (response.code === 20000) {
          row.rowImageUrls.push(response.data.fileUrl);
          console.log(fileList, file);
        }
      };
    },*/

    /*handleRowRemove(file, fileList) {
      // 仅同步文件列表
      this.rowFileList = fileList;
      // 这里确保文件移除时，也移除对应的预览
      this.rowImageUrls = this.rowImageUrls.filter(preview => preview.url !== URL.createObjectURL(file.raw));
      this.rowFileList = this.rowFileList.filter(preview => preview.url !== file.url);
      console.log(">>>>>>>>>> 删除之后",this.rowFileList)
    },*/


    handleCartPreview(file) {
      console.log(file);
    },

    // 删除图片预览时的回调
    handleRemoveCartPreview(index) {
      console.log(">>> 购物车里删图片")
      this.cartData.fileList.splice(index, 1);
      this.cartDataImageUrls.splice(index, 1);
    },

    /*handleRemoveRowPreview(row, index) {
      console.log(">>> 购物车里删图片")
      this.rowFileList.splice(index, 1);
      row.rowImageUrls.splice(index, 1);
    },*/

    // 删除文件时的回调（ElementUI 自带）
    handleCartRemove(file, fileList) {
      // 仅同步文件列表
      this.cartData.fileList = fileList;
      // 这里确保文件移除时，也移除对应的预览
      this.cartDataImageUrls = this.cartDataImageUrls.filter(preview => preview.url !== URL.createObjectURL(file.raw));
      this.cartData.fileList = this.cartData.fileList.filter(preview => preview.url !== file.url);
      console.log(">>>>>>>>>> 删除之后",this.cartData.fileList)
    },

    handleSelectionChange(val) {
      this.selectedRows = val; // 更新选中的数据
      let total = 0;
      this.selectedRows.forEach(row => {
        total += row.productPrice * row.quantity;
      });
      this.cartData.cartTotal = total;
    },

    selectable(row, index) {
      // 只允许选择第 1 和第 3 行
      // return index !== 1;
      console.log("...",  row, index)
      // this.selectedRows.push()
      return true;
    },

    // 添加商品到购物车
    addToCart(item) {
      // console.log(item)
      // const existingItem = this.cartItems.find(i => i.productId === item.productId && i.addressId === item.addressId);
      //
      //
      // if (existingItem) {
      //   existingItem.quantity += item.quantity;
      // } else {
          this.cartItems.push(item);
        // // 更新购物车商品总数
        this.cartCount++;
      // }
    },
    // 切换购物车弹窗显示状态
    toggleCart() {
      this.cartVisible = !this.cartVisible;
      if (this.cartVisible) {
        console.log(">>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>> zhixingle")
        // this.$nextTick(() => {
        //   // 确保弹窗和表格渲染完成后，再执行选择
        //   this.cartItems.forEach(item => {
        //     this.$refs.catTable.toggleSelection(item);
        //   });
        // });
        // this.calculateTotal();
      }
    },

    handleDialogOpen() {
      this.$nextTick(() => {
        const table = this.$refs.catTable;
        if (table) {
          // 选择所有行
          table.clearSelection(); // 清除所有选择
          this.cartItems.forEach(item => {
            table.toggleRowSelection(item, true); // 手动选中每一行
          });
        }
      });
    },

    handleAddress(value) {
      alert(value);
      console.log('选择了：', value);
      this.cartData.addressValue = value;
      this.cartData.addressDetails = value.address;
      this.cartData.phoneNumber = value.phone;
      this.cartData.nikeName = value.nikeName;

      this.cartData.addressId = value.id;
    },

    createOrderOne(row) {
      if (row.address == undefined ) {
        this.$Message.error('请选择快递地址!');
        console.log(JSON.stringify(this.addressPage));
        return;
      }
      if (row.rowImageUrls == undefined || row.rowImageUrls.length == 0) {
        this.$Message.error('请上传购买沟通凭证!');
        return;
      }

      if (row.quantity < row.orderMinNumber) {
        this.$Message.error("你的产品"+ row.productName +"的购买量不能少于" + row.orderMinNumber + "个")
        return;
      }

      const products = [{
        productId: row.productId,
        orderNumber: Number(row.quantity),
        addressId: row.addressId,
      }];

      const param = {
        productDTOS: products,
        examineImageUrls: row.rowImageUrls,
        contractUrl:""
      };

      console.log(">>>>>> createOrderOne +" , JSON.stringify(param))
      createOrder(param).then((data) => {
        if (data.code == 20000) {
          this.$message({
            message: data.msg,
            type: 'success'
          });
          row.address = "";
          row.addressName="";
          row.addressPhone="";
          row.rowImageUrls = [];
          row.addressId = "";
          this.$router.push('/order');
        } else {
          this.$Message.error(data.msg)
        }
      })

    },

    /**
     * 下单接口
     */
    createOrder() {
      //todo 做下参数校验
      console.log(JSON.stringify(this.selectedRows));
      const productList = [];

      const result = this.selectedRows.reduce((acc, obj) => {
        // 找到是否有相同的 'a' 和 'b' 键的项
        const existing = acc.find(item => item.productId === obj.productId && item.addressId === obj.addressId);
        if (existing) {
          // 如果找到匹配项，累加 'value' 字段
          existing.quantity += obj.quantity;
        } else {
          // 如果没有匹配项，直接添加新项
          acc.push({ ...obj });
        }

        return acc;
      }, []);

      for (let i = 0; i < result.length; i++) {
        const row = result[i];
        if (row.addressId == undefined) {
          this.$message.error({
            message: "请选择快递地址",
            duration: 3000,
            top: this.$refs.catDialog.$el.getBoundingClientRect().top + 50 // 获取弹窗顶部位置并在其下方显示
          });
          return;
        }
        if (row.quantity < row.orderMinNumber) {
          this.$message.error({
            message: "同一个地址，你的产品"+ row.productName +"的购买量不能少于" + row.orderMinNumber + "个",
            duration: 3000,
            top: this.$refs.catDialog.$el.getBoundingClientRect().top + 50 // 获取弹窗顶部位置并在其下方显示
          });
          return;
        }

        if (row.quantity > row.orderMaxNumber) {
          this.$message.error({
            message: "同一个地址，你的产品"+ row.productName +"的购买量不能大于" + row.orderMaxNumber + "个",
            duration: 3000,
            top: this.$refs.catDialog.$el.getBoundingClientRect().top + 50 // 获取弹窗顶部位置并在其下方显示
          });
          return;
        }

        productList.push({
          productId: row.productId,
          orderNumber: row.quantity,
          addressId: row.addressId
        });
        // 进行其他操作
      }

      if (this.cartDataImageUrls.length === 0) {
        this.$message.error({
          message: "请上传沟通凭证信息",
          duration: 3000,
          top: this.$refs.catDialog.$el.getBoundingClientRect().top + 50 // 获取弹窗顶部位置并在其下方显示
        });
        return;
      }

      const param = {
        productDTOS: productList,
        examineImageUrls: this.cartDataImageUrls,
        contractUrl:this.cartData.contractUrl
      };
      console.log(">>>>>> createOrder +" , JSON.stringify(param))
      createOrder(param).then((data) => {
        if (data.code == 20000) {
          this.dialogVisible2 = false;
          this.$message({
            message: data.msg,
            type: 'success'
          });
          this.cartData = {};
          this.cartVisible = false;
          this.cartCount = 0;
          this.cartItems = [];
          this.cartDataImageUrls = [];
          this.$router.push('/order');
        } else {
          this.$Message.error(data.msg)
        }
      })
    },

    calculateTotal() {
      console.log("=====================> calculateTotal")
      let total = 0;
      this.cartItems.forEach(item => {
        total += item.productPrice * item.quantity;
      });
      this.cartData.cartTotal = total;
      console.log("=====================> calculateTotal" + this.cartData.cartTotal)
    },

    add() {
      this.product.productId = "";
      this.product.productType = "";
      this.product.material = "";
      this.product.dimension = "";
      this.product.productDescribe = "";
      this.product.orderMinNumber = "";
      this.product.orderMaxNumber = "";
      this.product.productName = "";
      this.product.productPrice = "";
      this.product.data = "";
      this.product.productOrders = "";
      this.product.expectedDeliveryTime = "";
      this.product.examineTime = "";
      this.product.productUrls = [];
      this.productFile = [];

      this.product.productUrls = "";
      this.product.file = null;
      this.product.mode = 0;

      this.product.imageUrls = [];
      this.dialogVisible = true;
    },

    edit(item) {
      this.product.productId = item.productId;
      this.product.productDescribe = item.productDescribe;
      this.product.productSpecs = item.productSpecs;
      this.product.productName = item.productName;
      this.product.productPrice = item.productPrice;
      this.product.expectedDeliveryTime = item.expectedDeliveryTime;
      this.product.examineTime = item.examineTime;
      this.product.data = [item.expirationDateStart, item.expirationDateEnd];
      this.productFile = item.imageLists;
      this.product.orderMinNumber = Number(item.orderMinNumber);
      this.product.orderMaxNumber = item.orderMaxNumber;
      this.product.productType = item.productType;
      this.product.dimension = item.dimension;
      this.product.material = item.material;

      this.product.mode = 1;
      this.product.imageUrls = [];
      this.dialogVisible = true;
    },

    showDeleteDialog(item) {
      this.itemToDelete = item; // 记录要删除的项
      this.dialogDelete = true; // 显示对话框
    },

    handleDelete() {
      if (this.itemToDelete) {
        this.removeProduct(this.itemToDelete);
        this.itemToDelete = null; // 清空当前删除项
      }
    },

    removeProduct(product) {
      removeProduct(product.productId).then((data) => {
        if (data.code == 20000) {
          this.$message({
            message: data.msg,
            type: 'success'
          });
          this.productList();
        } else {
          this.$Message.error(data.msg)
        }
      })
    },

    createProduct(product) {
      this.product.examineTime = dayjs(product.examineTime).endOf('day').format('YYYY-MM-DD HH:mm:ss');
      this.product.expectedDeliveryTime = dayjs(product.expectedDeliveryTime).format('YYYY-MM-DD HH:mm:ss');
      this.product.expirationDateStart = dayjs(product.data[0]).format('YYYY-MM-DD HH:mm:ss');
      this.product.expirationDateEnd = dayjs(product.data[1]).endOf('day').format('YYYY-MM-DD HH:mm:ss');

      this.product.imageUrls = product.productUrls;

      console.log(JSON.stringify(product));
      createProduct(this.product).then((data) => {
        if (data.code == 20000) {
          this.dialogVisible = false;
          this.$message({
            message: data.msg,
            type: 'success'
          });
          this.productList();
        } else {
          this.$Message.error(data.msg)
        }
      })
    },

    updateProduct(product) {
      this.product.examineTime = dayjs(product.examineTime).endOf('day').format('YYYY-MM-DD HH:mm:ss');
      this.product.expectedDeliveryTime = dayjs(product.expectedDeliveryTime).format('YYYY-MM-DD HH:mm:ss');
      this.product.expirationDateStart = dayjs(product.data[0]).format('YYYY-MM-DD HH:mm:ss');
      this.product.expirationDateEnd = dayjs(product.data[1]).endOf('day').format('YYYY-MM-DD HH:mm:ss');
      // this.product.imageUrls = product.productUrls.map(file => file.fileUrl);
      this.product.imageUrls = this.productFile;
      // this.product.imageUrls = product.productUrls;
      console.log(JSON.stringify(product));

      updateProduct("?" + "productId="+this.product.productId, this.product)
          .then((data) => {
            if (data.code == 20000) {
              this.$message({
                message: data.msg,
                type: 'success'
              });
              this.dialogVisible = false;
              this.productList();
            } else {
              this.$Message.error(data.msg)
            }
          })
    },

    update(name) {
      this.$refs[name].validate((valid) => {
        if (valid) {
            const url = '/product';
            const formData = new FormData();
            const file = this.product.file;
            if (file != undefined) {
              formData.append('file', file);
            }
            this.product.expirationDateStart_Param = this.product.data[0];
            this.product.expirationDateEnd_Param = this.product.data[1];
            formData.append('productId', this.product.productId);
            formData.append('productName', this.product.productName);
            formData.append('productDescribe', this.product.productDescribe);
            formData.append('productSpecs', this.product.productSpecs);
            formData.append('productPrice', this.product.productPrice);
            formData.append('expirationDateStart_Param', this.product.expirationDateStart_Param);
            formData.append('expirationDateEnd_Param', this.product.expirationDateEnd_Param);
            formData.append('productOrders', this.product.productOrders);
            formData.append('expressFee', this.product.expressFee);

            axios.post("/movie" + url, formData, {
              headers: {
                Authorization: "Bearer " + window.sessionStorage.getItem('token'), // 根据实际情况设置token
              }
            }).then(res => {
              this.dialogVisible = false;
              if (res.data.code == 20000) {
                this.pageNo = 1
                this.size = 15
                this.$Message.info(res.data.msg);
                this.productList();
              }else{
                // document.getElementById('msgUpdate').innerHTML = data.msg;
              }
            }).catch(err => {
              console.log(err);
            })
        } else {
          this.$Message.error('必填项有为空，请把为空的填上!');
        }
      })
    },

    dialog(row, type) {
      this.product.productId = row.productId;
      this.product.productDescribe = row.productDescribe;
      this.product.productSpecs = row.productSpecs;
      this.product.productName = row.productName;
      this.product.productPrice = row.productPrice;
      this.product.expirationDateStart_Param = row.expirationDateStart;
      this.product.expirationDateEnd_Param = row.expirationDateEnd;
      this.product.data = [row.expirationDateStart,row.expirationDateEnd];
      this.product.productOrders = row.productOrders;
      this.product.expressFee = row.expressFee;
      this.product.imageUrl = row.imageUrl;

      this.product.printFee = row.printFee;
      this.product.inspectFee = row.inspectFee;
      this.product.packFee = row.packFee;
      this.product.accessoriesFee = row.accessoriesFee;
      this.product.manageFee = row.manageFee;
      this.product.serviceFee = row.serviceFee;

      if (type == 1) {
        expressDetail().then((data) => {
          if (data.code == 20000) {
            this.product.expressDetailList = data.data.list;
          }
        })
        this.product.mode = 1;
        this.dialogVisible = true
      }
      if (type == 2) {
        getAddress().then((data) => {
          this.product.addressList = data.data.list;
        })
        this.orderdialogVisible = true;
        this.product.productNums = '';
        this.product.addressId = '';
        this.product.products = row.productId
      }
    },

    remove(productId) {
      deleteProduct(productId).then((data) => {
        this.$Message.info(data.msg);
        if (data.code == 20000) {
          this.productList();
        }
      })
    },

    handleSizeChange(a) {
      this.queryData.size = a;
      this.productList()
    },

    changePage(page) {
      this.queryData.pageNo = page;
      this.productList()
    },

    changeExpressFee(number){
      console.log(number);
      expressFee(this.product.productSpecs,number).then((data) => {
        if (data.code == 20000) {
          this.product.printFee = data.data;
          document.getElementById('span_id').innerText=data.data;
        }else{
          this.$Message.error(data.msg);
        }
      })
    },
    deleteCart(row){
      console.log(row.row.productId+","+row.row.addressId)
      console.log(this.cartItems[0]);
      // this.cartItems = this.cartItems.filter(item => item.productId !== row.row.productId ||  item.addressId !==row.row.addressId);
      this.cartItems = this.cartItems.filter(item => item.serialNumber !== row.row.serialNumber);
      this.cartCount--;
      console.log("购物车里面的数据"+this.cartItems[0]);
    },
  },
  components:{
    ImageCarousel,
    DeleteConfirmation
  },

  created() {
    this.productList();
    this.getAddress();
  },

}
</script>

<style scoped>
.upload-component {
  position: relative;
  margin-bottom: 20px; /* 上传按钮和文件列表之间的间距 */
}

.el-icon-upload {
  position: relative;
}

.image-preview img {
  max-width: 100%;  /* 让图片自适应容器大小 */
  max-height: 300px;  /* 限制图片最大高度 */
  border-radius: 8px;  /* 可选：圆角效果 */
  margin-top: 20px;  /* 图片上方间距 */
}

img {
  border-radius: 8px;
}
.button-del {
  background-color: red;
  color: white;
  border: none;
  right: 5px;
  padding: 5px 10px;
  cursor: pointer;
}
/*button:hover {
  background-color: darkred;
}*/


.uploaded-images {
  display: flex;
  flex-wrap: wrap;  /* 使图片在达到容器边界时换行 */
  gap: 10px;  /* 设置图片之间的间距 */
}
.delete-button {
  position: absolute;  /* 使用绝对定位将按钮放置在图片的右上角 */
  top: 5px;
  right: 5px;
  padding: 5px;
}

.image-card {
  width: 100px;
  height: 100px;
  overflow: hidden;
  border-radius: 8px;  /* 可选，给图片卡片添加圆角效果 */
}


.el-upload-list .el-upload-list__item {
  margin-right: 10px;
  margin-bottom: 10px;
}

.preview-item el-button {
  position: absolute;
  top: 5px;
  right: 5px;
}

.query-container {
  //position: sticky;
  top: 70px; /* 距离菜单顶部固定的距离 */
  background-color: #fff;
  padding: 20px 20px;
  margin: 20px 20px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  z-index: 10;
  height: 80px;
}

.query-row {
  margin: 0;
}

.product-text{
  font-size: 14px;
  color: #d11d1d;
}

.content {
  margin-top: -20px;  /* 内容区域距离查询区域的距离，避免被遮挡 */
  padding: 20px;
}

.product-card {
  margin-bottom: 20px;
}

.product-image {
  width: 100%;
  height: 350px;
  object-fit: cover;
  margin-bottom: 10px;
}

.product-price {
  font-size: 18px;
  font-weight: bold;
  color: #f56c6c;
  text-align: right;
}

.table {
  background: #FFF;
  padding: 15px;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
  height: auto;
}

.top {
  margin-bottom: 10px;
}

.bottom {
  margin-top: 10px;
  padding-bottom: 25px;
}

.scrollable-text {
  display: inline-block;
  width: 80%;              /* 设置容器的宽度 */
  white-space: nowrap;       /* 禁止文本换行 */
  overflow-x: scroll;        /* 保持滚动效果，但显示滚动条 */
  text-overflow: clip;       /* 不使用省略号 */
  scrollbar-width: none;     /* Firefox: 隐藏滚动条 */
}

.scrollable-text::-webkit-scrollbar {
  display: none;             /* Webkit-based browsers: 隐藏滚动条 */
}

.show-form {
  font-size: 10px;
  margin-left: 8px;
}

.tableTitle {
  position: relative;
  margin: 0 auto;
  width: 100%;
  height: 1px;
  background-color: #d4d4d4;
  text-align: center;
  /*font-size: 16px;*/
  color: rgba(101, 101, 101, 1);
}

.container {
  display: flex;                    /* 启用 Flexbox 布局 */
  justify-content: space-between;    /* 让子元素在父容器中均匀分布 */
  width: 100%;                       /* 容器宽度占满100%，便于分布 */
}

.form-item-content {
  display: flex;
  justify-content: space-between; /* 使 div 在一行内平均分布 */
}

.item {
  width: 24%; /* 控制每个 div 的宽度，4个就用24%，保留4%的空隙 */
  text-align: center; /* 可选，设置内容居中 */
}

.item {
  width: 25%;                     /* 子元素的宽度 */
  height: 50px;                     /* 子元素的高度 */
  display: flex;                    /* 如果需要内部内容对齐，可以启用 flex */
  justify-content: center;          /* 内容水平居中 */
  align-items: center;              /* 内容垂直居中 */
}

input[type=number]::-webkit-inner-spin-button {
  -webkit-appearance: none;
}

.box-card {
  //height: 480px;
  height: auto;
}

/*购物车*/
.cart-icon {
  position: fixed;
  bottom: 80px;
  right: 80px;
  z-index: 1000;
  cursor: pointer;
}
.cart-icon.has-items .el-button {
  background-color: #40ff00; /* 添加商品时，改变图标颜色 */
}
.flex-right {
  display: flex;
  justify-content: flex-end;  /* 将所有子元素靠右对齐 */
  align-items: center;        /* 如果需要垂直居中，可以使用这个 */
}
.product-item {
  //display: flex;                /* 使用flexbox布局 */
  margin-bottom: 0px;
  align-items: flex-start;      /* 垂直方向上与容器顶部对齐 */
  justify-content: flex-start;  /* 水平方向上与容器左侧对齐 */
}

.product-item strong {
  white-space: nowrap;          /* 防止产品名称换行 */
  margin-right: 10px;           /* 产品名称和内容之间的间距 */
}

.show-overflow-tooltip {
  display: inline-block;        /* 保持为行内块元素 */
  word-wrap: break-word;        /* 当单词过长时换行 */
  max-width: 100%;              /* 限制最大宽度 */
  white-space: normal;          /* 允许换行 */
  text-align: center;           /* 使文本内容水平居中 */
  overflow: hidden;             /* 隐藏溢出的内容 */
  text-overflow: ellipsis;      /* 超出部分显示省略号 */
  flex-grow: 1;                 /* 让文本部分占据剩余空间 */
}
</style>
